$shm_hitalama_map_float $rise_resize_ratio
	Map_page $shm_hitalama_map_page
	stickable? false
	zoom 1
	style *
		^
		transition <= transition <= transition_smooth \top 0.2s, left 0.2s, right 0.2s, bottom 0.2s, width 0.2s, height 0.2s
	sub_common /
		<= Drag_overlap $mol_view
			event *
				pointerdown? <=> pointerdown? null
		^ outline
		^ edges
		^ toolbar
		^ sidebar
	outline /
		<= Outline_top $mol_view
			style *
				transform <= resizer_line_y_transform \
		<= Outline_left $mol_view
			style *
				transform <= resizer_line_x_transform \
		<= Outline_bottom $mol_view
			style *
				transform <= resizer_line_y_transform \
		<= Outline_right $mol_view
			style *
				transform <= resizer_line_x_transform \
	toolbar /
		<= Toolbar $mol_view
			style *
				transform <= toolbar_transform \
				top <= toolbar_style_top \0
			sub <= toolbar_content /
	toolbar_content /
	sidebar /
		<= Sidebar $mol_view
	Top_edge $shm_hitalama_map_float_resizer
		repos_x* <= repos_x*
		repos_y* <= repos_y*
		on_drag_start? <=> resize_start?
		on_drag_end? <=> resize_end?
		y? <=> top_edge_y?
		transform <= resizer_line_y_transform \
	Left_edge $shm_hitalama_map_float_resizer
		repos_x* <= repos_x*
		repos_y* <= repos_y*
		on_drag_start? <=> resize_start?
		on_drag_end? <=> resize_end?
		x? <=> left_edge_x?
		transform <= resizer_line_x_transform \
	Bottom_edge $shm_hitalama_map_float_resizer
		repos_x* <= repos_x*
		repos_y* <= repos_y*
		on_drag_start? <=> resize_start?
		on_drag_end? <=> resize_end?
		y? <=> bottom_edge_y?
		transform <= resizer_line_y_transform \
	Right_edge $shm_hitalama_map_float_resizer
		repos_x* <= repos_x*
		repos_y* <= repos_y*
		on_drag_start? <=> resize_start?
		on_drag_end? <=> resize_end?
		x? <=> right_edge_x?
		transform <= resizer_line_x_transform \
	Top_left_edge_ratio $shm_hitalama_map_float_resizer
		repos_x* <= repos_x*
		repos_y* <= repos_y*
		on_drag_start? <=> resize_start?
		on_drag_end? <=> resize_end?
		y? <=> top_left_edge_ratio_y?
		transform <= resizer_line_y_transform \
	Top_right_edge_ratio $shm_hitalama_map_float_resizer
		repos_x* <= repos_x*
		repos_y* <= repos_y*
		on_drag_start? <=> resize_start?
		on_drag_end? <=> resize_end?
		y? <=> top_right_edge_ratio_y?
		transform <= resizer_line_y_transform \
	Bottom_left_edge_ratio $shm_hitalama_map_float_resizer
		repos_x* <= repos_x*
		repos_y* <= repos_y*
		on_drag_start? <=> resize_start?
		on_drag_end? <=> resize_end?
		y? <=> bottom_left_edge_ratio_y?
		transform <= resizer_line_y_transform \
	Bottom_right_edge_ratio $shm_hitalama_map_float_resizer
		repos_x* <= repos_x*
		repos_y* <= repos_y*
		on_drag_start? <=> resize_start?
		on_drag_end? <=> resize_end?
		y? <=> bottom_right_edge_ratio_y?
		transform <= resizer_line_y_transform \
	Top_left_edge $shm_hitalama_map_float_resizer
		repos_x* <= repos_x*
		repos_y* <= repos_y*
		on_drag_start? <=> resize_start?
		on_drag_end? <=> resize_end?
		y? <=> top_edge_y?
		x? <=> left_edge_x?
		transform <= resizer_transform \
	Top_right_edge $shm_hitalama_map_float_resizer
		repos_x* <= repos_x*
		repos_y* <= repos_y*
		on_drag_start? <=> resize_start?
		on_drag_end? <=> resize_end?
		y? <=> top_edge_y?
		x? <=> right_edge_x?
		transform <= resizer_transform \
	Bottom_left_edge $shm_hitalama_map_float_resizer
		repos_x* <= repos_x*
		repos_y* <= repos_y*
		on_drag_start? <=> resize_start?
		on_drag_end? <=> resize_end?
		y? <=> bottom_edge_y?
		x? <=> left_edge_x?
		transform <= resizer_transform \
	Bottom_right_edge $shm_hitalama_map_float_resizer
		repos_x* <= repos_x*
		repos_y* <= repos_y*
		on_drag_start? <=> resize_start?
		on_drag_end? <=> resize_end?
		y? <=> bottom_edge_y?
		x? <=> right_edge_x?
		transform <= resizer_transform \

$shm_hitalama_map_float_resizer $rise_resize_edge
	style *
		^
		transform <= transform \
